import styled from '@emotion/styled'

import { transparentize } from 'polished'
import { getEmbeddedViewFlag } from 'portal-modules/common/utils/get-embedded-flag'

export const StyledCard = styled('div')`
  background-color: ${({ theme }) => getEmbeddedViewFlag() ? theme.embedded.foreground_color : theme.mode.isDark ? theme.mode.card_background_color : theme.gray.highlight};
  border: 1px solid ${({ theme }) => getEmbeddedViewFlag() ? theme.embedded.input_border_outline : theme.fields.border};
  transition: all 250ms ease-in-out;
  pointer-events: ${props => (props.isAvailable ? 'all' : 'none')};
  border-radius: 8px;

  &.selected {
    background-color: ${({ theme }) => getEmbeddedViewFlag() ? theme.embedded.foreground_color : theme.white.base};
    border-color: ${({ theme }) => getEmbeddedViewFlag() ? theme.blue.system_blue : transparentize(0.5, theme.primary.base)};
    border-radius: 8px;
  }
`

export const StyledApplePayHeaderText = styled('div')`
width: 150px;
color: ${({ theme }) => theme.gray.dark};
font-family: Inter;
font-weight: bold;
font-size: 13px;
letter-spacing: 0.36px;
line-height: 1.5;
display: block;
`

export const StyledUnionPayHeaderText = styled('div')`
  height: 12px;
  width: 150px;
  color: ${({ theme }) => theme.gray.dark};
  font-family: Inter;
  font-weight: bold;
  font-size: 13px;
  letter-spacing: 0.36px;
  line-height: 1.5;
  display: block;
`
export const StyleUnionPayDiv = styled('div')`
  margin-top: -50px;
`

export const StyledButton = styled('button')`
  width: 100%;
  min-height: 72px;
  height: 100%;
  background: none;
  border: 1px solid white;
  font-family: ${({ theme }) => theme.fonts.body};
  border-radius: 8px;
  opacity: 0.5;
  padding: 12px;
  text-align: left;
  transition: all 150ms ease-in-out;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  /* Content container to handle overflow */
  > * {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:focus {
    outline: 1px solid ${p => p.theme.fields.focus};
    outline-offset: 2px;
  }

  &.selected {
    opacity: 1;
  }

  &:hover:not(:disabled) {
    opacity: 1;
    border: 1px solid ${p => p.theme.fields.focus};
  }

  &:disabled {
    opacity: 0.75;
    background: ${({ theme }) => getEmbeddedViewFlag() ? theme.embedded.foreground_color : theme.white.base};
  }

  @media only screen and (min-width: 768px) {
    min-height: 136px;
  }
`

export const StyledButtonDiv = styled('div')`
  width: 100%;
  height: 100%;
  background: none;
  border: 1px solid white;
  font-family: ${({ theme }) => theme.fonts.body};
  border-radius: 8px;
  opacity: 0.5;
  padding: 12px;
  text-align: left;
  transition: all 150ms ease-in-out;

  &:focus {
    outline: 1px solid ${p => p.theme.fields.focus};
    outline-offset: 2px;
  }

  &.selected {
    opacity: 1;
  }

  &:hover:not(:disabled) {
    opacity: 1;
    border: 1px solid ${p => p.theme.fields.focus};
  }

  &:disabled {
    opacity: 0.75;
    background: ${({ theme }) => getEmbeddedViewFlag() ? theme.embedded.foreground_color : theme.white.base};
  }
`

export const StyledCardHeader = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 8px;
`

export const StyledRoutingNumber = styled('span')`
  color: ${({ theme }) => getEmbeddedViewFlag() ? theme.secondary.base : theme.text.dark};
  font-size: 12px;
  flex-basis: 25%;
  text-align: right;

  span {
    color: ${({ theme }) => theme.text.light};
  }
`

export const StyledSortCode = styled('span')`
  color: ${({ theme }) => getEmbeddedViewFlag() ? theme.secondary.base : theme.text.dark};
  font-size: 12px;
  flex-basis: 35%;
  text-align: right;

  span {
    color: ${({ theme }) => theme.text.light};
  }
`

export const StyledHeaderText = styled('span')`
  color: ${({ theme }) => getEmbeddedViewFlag() ? theme.secondary.base : theme.text.dark};
  font-size: 12px;

  span {
    color: ${({ theme }) => theme.text.light};
  }
`

export const StyledNickName = styled('div')`
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => getEmbeddedViewFlag() ? theme.secondary.base : theme.text.medium};
  padding-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media only screen and (min-width: 400px) {
    color: ${({ theme }) => getEmbeddedViewFlag() ? theme.secondary.base : theme.text.dark};
    font-size: 11px;
    font-weight: bold;
  }
`

export const StyledName = styled('div')`
  font-size: 16px;
  color: ${({ theme }) => getEmbeddedViewFlag() ? theme.primary.base : theme.text.medium};
  padding-bottom: 4px;

  @media only screen and (min-width: 400px) {
    color: ${({ theme }) => getEmbeddedViewFlag() ? theme.primary.base : theme.text.dark};
    font-size: 13px;
    font-weight: 500;
  }
`

export const StyledMaskedCardNumber = styled('div')`
  font-size: 14px;
  padding-bottom: 4px;
  color: ${({ theme }) => getEmbeddedViewFlag() ? theme.primary.base : theme.mode.isDark && theme.mode.card_text_color };
`

export const StyledConvFee = styled('div')`
  font-size: 12px;
  font-style: italic;
  color: ${({ theme }) => getEmbeddedViewFlag() ? theme.secondary.base : theme.text.medium};

  @media only screen and (min-width: 400px) {
    font-size: 11px;

    &.selected {
      color: ${({ theme }) => theme.primary.base};
    }
  }

  @media only screen and (max-width: 350px) {
    font-size: 11px;
  }
`

export const StyledWrapperDiv = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const StyledReason = styled('span')`
  font-size: 12px;
  font-style: italic;
  color: ${({ disableFlexPaymentAccount = false, theme }) =>
    disableFlexPaymentAccount ? theme.green.base : theme.error.base};
  position: relative;
`

export const StyledLoaderDiv = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StyledOneTapPayLoader = styled('div')`
  display: flex;
  position: absolute;
  top: 200px;
  left: 230px;
  justify-content: center;
  align-items: center;

  @media only screen and (max-width: 767px) {
    position: absolute;
    top: 10px;
    left: 100px;
  }
`

// Flex related
export const StyledFlexInnerWrapper = styled('div')`
  display: block;
  position: relative;
`

export const StyledFlexInfoText = styled('div')`
  font-size: 12px;
  font-style: italic;
  position: relative;
`

export const StyledFlexEnrolledInfo = styled('span')`
  font-size: 12px;
  font-style: italic;
  color: ${({ theme }) => theme.green.base};
  position: absolute;
  top: 14px;
  right: 0px;
`
export const StyledFlexEnrolledTitle = styled('div')`
  font-size: 16px;
  color: ${({ theme }) => theme.green.base};
  padding-bottom: 4px;

  @media only screen and (min-width: 400px) {
    color: ${({ theme }) => theme.green.base};
    font-size: 12px;
    font-weight: 500;
  }
`

export const StyledSmallScreenFlexReason = styled('span')`
  font-size: 10px;
  font-style: italic;
  color: ${({ theme }) => theme.text.medium};
  position: relative;
`

export const StyledCardDetails = styled('div')`
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.secondary.base : theme.text.dark};
  font-size: 11px;
  padding-top: 8px;
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const StyledCardHolderName = styled('span')`
  margin-right: auto;
`
export const StyledPadCardFooter = styled('div')`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-top: 8px;
  font-weight: 300;
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.secondary.base : theme.text.dark};
`
export const StyledPadCardDeailsDiv = styled('div')`
  display: flex;
  flex-direction: column;
  font-size: 15px;

  & > span:first-child {
    font-size: 8px;
  }
`
